module.exports = __webpack_public_path__ + "img/mold.100dbe11.jpg";